import { combineReducers } from '@reduxjs/toolkit';

import byId from './byId';

/**
 * @typedef {{
 * byId: import('./byId').ByIdState,
 * }} AdvicesState
 */

export default combineReducers({
  byId,
});
